import useTranslate from "@/hooks/useTranslate/useTranslate";

import type { I_UseValidate_Return } from "../index";

export default function seriasAndNumberMDValidator(value: string): I_UseValidate_Return {
    if (!value) {
        return {
            status: false,
            message: useTranslate("tiw__validation__required"),
        };
    }

    if (!/^([A-Z]\d{7,8})|([A-Z]{2}\d{7})$/.test(value)) {
        return {
            status: false,
            message: useTranslate("tiw__validation__seriasAndNumberMD_bad"),
        };
    }

    return {
        status: true,
        message: useTranslate("tiw__validation__success"),
    };
}
